import BASE_API from '@/api/dataBase';
export default {
  data() {
    return {
      queryData: {
        businessDepartmentCode: '',
        businessDepartmentName: '',
      },
      curDepartmentList: [],
      tableData: [], // 表格数据
      selectedItems: [],
    };
  },
  methods: {
    getDefaultSearchData() {
      return {
        businessDepartmentCode: this.userInfo.departmentCode,
        businessDepartmentName: this.userInfo.departmentName,
      };
    },
    async valueChangeHandler(type, { val }) {
      console.log('valueChanged', type, val);
      if (type == 'platformCompanyCode') {
        this.queryData.platformCompanyName = this.companyList.find(
          (item) => item.personCompanyCode == val
        )?.personCompanyName;
        console.log(
          '平台公司',
          this.queryData.platformCompanyCode,
          this.queryData.platformCompanyName,
          this.companyList
        );
        this.queryData = {
          ...this.queryData,
          businessDepartmentCode: null,
          businessDepartmentName: null,
        };
        if (!val) {
          this.departmentList = [];
        } else {
          this.department(val);
        }
      } else if (type == 'businessDepartment') {
        this.queryData.businessDepartmentName = this.departmentList.find(
          (item) => item.value == val
        )?.label;
      }
    },
    // 获取部门
    department(contractCompanyNo) {
      let params = {
        id: this.userInfo.userCode,
        userCode: this.userInfo.userCode,
        personName: this.userInfo.userName,
        personCompanyCode: contractCompanyNo,
      };
      this.$axios.post(BASE_API.GET_PERSON_API, params).then((res) => {
        if (res.data.code === 0) {
          this.departmentList = res.data.data.personDepartmentInfo || [];
          if (this.departmentList.length)
            this.departmentList = this.departmentList.map((item) => {
              return {
                ...item,
                value: item.personDepartmentCode,
                label: item.personDepartmentName,
              };
            });
          console.log('获取部门', this.departmentList);
        } else {
          this.$alert(res.data.msg);
        }
      });
    },
    // 获取表格数据
    async getTableData() {
      // console.log(search, '搜索');
      let params = {};
      params = { ...this.queryData };
      console.log('rawParams', params);
      //处理日期
      params.startContractSignDate = this.formatDateCustom(params.startContractSignDate, false);
      params.endContractSignDate = this.formatDateCustom(params.endContractSignDate, false);
      params.startContractEffectDate = this.formatDateCustom(params.startContractEffectDate, false);
      params.endContractEffectDate = this.formatDateCustom(params.endContractEffectDate, false);
      params.startContractExpireDate = this.formatDateCustom(params.startContractExpireDate, false);
      params.endContractExpireDate = this.formatDateCustom(params.endContractExpireDate, false);
      //处理多选值
      // params.createDepartmentNo = Array.from(params.createDepartmentNo).join(',');
      // params.saleDepartmentNo = Array.from(params.saleDepartmentNo).join(',');
      //自动处理了
      if (params.chargePersonId) {
        params.chargePersonId = Array.from(params.chargePersonId)
          .map((item) => item.id)
          .join(',');
      }

      if (params.contractType) {
        params.contractType = Array.from(params.contractType).join(',');
      }
      if (params.contractStatus) {
        params.contractStatus = Array.from(params.contractStatus).join(',');
      }

      if (params.signTitle && params.signTitle.length != 0) {
        params.signTitle = params.signTitle
          .map((id) => {
            let title = this.signTitleList.find((item) => item.value == id);
            if (title) {
              return title.label;
            }
            return '';
          })
          .join(',');
      } else {
        delete params.signTitle;
      }

      if (!params.platformCompanyName) {
        delete params.platformCompanyName;
      }

      if (!params.businessDepartmentCode) {
        delete params.businessDepartmentCode;
      }
      if (params.customerCode) {
        params.customerCode = Array.from(params.customerCode)
          .map((item) => item.partnerCode)
          .join(',');
      }
      if (params.serviceTypeName && params.serviceTypeName.length) {
        let array = Array.from(params.serviceTypeName);
        params.serviceTypeName = array
          .map((item) => {
            return this.serviceTypeDictList.find((ele) => ele.value == item)?.label;
          })
          .join(',');
      } else {
        params.serviceTypeName = null;
      }

      // if (params.businessDepartmentCode) {
      //   params.businessDepartmentCode = Array.from(params.businessDepartmentCode).join(',');
      // }
      params.pageNum = this.$refs.siruiTable.page.pageNum;
      params.pageSize = this.$refs.siruiTable.page.pageSize;
      params.isCS = 'O'; //其他合同
      // params.platformCompanyName = this.userInfo.companyName;
      // params.businessDepartmentCode = this.userInfo.departmentCode;
      params.adminFlag = this.userInfo.adminFlag;
      params = this.filterEmpty(params);
      console.log('processedParams', params);
      this.loading = true;
      const { data } = await this.getContractList(params);
      this.loading = false;

      if (data) {
        console.log('contractRes', data);
        this.tableData = data.data.list || [];
        // this.$refs.siruiTable.setPageNum(data.data.pageNum);
        this.$refs.siruiTable.setPageTotal(data.data.total);
        // this.$refs.siruiTable.setPageSize(data.data.size);
        // this.$refs.siruiTable.setPagesCount(data.data.pages);
      }
      //清空选择fixme
      this.selectedItems = [];

      this.loading = false;
    },
  },
  mounted() {},
};
